import { useTranslation } from "react-i18next";

import Input from "../../../../components/Form/Input/input";
import { FormGroup } from "../../../../components/Form/styles";
import { BusinessCard } from "../../../../services/api";

const prefix = "pages.businessCard.form";

/** The limits of a card, the same the API cuts at (see `BusinessCard::MAX_*`). */
export const BUSINESS_CARD_MAX = { name: 60, role: 60 } as const;

type TextKey = keyof typeof BUSINESS_CARD_MAX;

type Props = {
  card: BusinessCard;
  onChange: (card: BusinessCard) => void;
};

// A text field of the card
const TextField = ({ card, onChange, field }: Props & { field: TextKey }) => {
  const { t } = useTranslation();
  return (
    <FormGroup>
      <Input
        id={`card-${field}`}
        type="text"
        value={card[field] || ""}
        maxLength={BUSINESS_CARD_MAX[field]}
        onChange={event => onChange({ ...card, [field]: event.target.value })}
        label={t(`${prefix}.${field}`)}
      />
    </FormGroup>
  );
};

/** What the card shows: the name and what the person does. */
export const CardFields = (props: Props) => (
  <>
    <TextField {...props} field="name" />
    <TextField {...props} field="role" />
  </>
);
